module.exports = __webpack_public_path__ + "static/media/bg_CrossAereo.63ebcdf6.jpg";